import { validationComment } from "api/interna-api";
import Button from "components/atoms/Button";
import Fielderror from "components/atoms/Fielderror";
import Icon from "components/atoms/Icon";
import Link from "components/atoms/Link";
import LoadingState from "components/atoms/LoadingState";
import TextareaField from "components/atoms/TextareaField";
import {
  FieldcellExtended,
  FieldRowExtended,
  FormInputUserUnLogging,
  FormInputUserUnLoggingInputWrapper,
  FormInputUserUnLoggingTextfield,
  LoggedUserInfo,
  LoggedUserInfoBar,
  LogoutTextLink,
  OtherAction,
  SubmitBlock,
} from "components/pages/ProductDetailPage/styled";
import { getObject, notEmptyObject } from "utils/utils-common";
import { useSelector } from "hooks/useApp";
import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import {
  requestPostComment,
  resetComment,
} from "redux/actions/general/comment";
import "./index.scss";
import { KEY_CAPTCHA } from "constants/env";

interface RatingCommentFormProps {
  ratingId: number;
  onSubmitComment: (success: boolean) => void;
  onLogout: () => void;
}

type FormData = {
  customer_name?: string;
  customer_phone: string;
  customer_email: string;
  comment: string;
};

const RatingCommentForm: React.FC<RatingCommentFormProps> = ({
  ratingId,
  onLogout,
  onSubmitComment,
}) => {
  const { handleSubmit, getValues, formState, errors, register } = useForm<
    FormData
  >({
    mode: "onBlur",
    defaultValues: {},
  });
  const dispatch = useDispatch();
  const touched = Object.values(formState.touched);
  const { userInfor: userInformation } = useSelector(state => state);
  const { comment } = useSelector(state => state.general);
  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = (data: any) => {
    setIsLoading(true);

    const {
      replyContent,
      customer_name,
      customer_email,
      customer_phone,
    } = data;

    if (!customer_email) {
      setIsLoading(false);
      toast.error("Đã xảy ra lỗi! Email không tồn tại!");
    } else {
      // Validation account:
      validationComment({
        phone: customer_phone || "123456789",
        email: customer_email,
        ratingId,
      })
        .then(data => {
          if (data.accept) {
            // If pass validation => approve for submit rating data:
            dispatch(
              requestPostComment({
                rating_id: ratingId,
                customer_name,
                customer_email,
                customer_phone,
                comment: replyContent,
              }),
            );
          } else {
            toast.error("Bạn không có quyền bình luận!");
          }
        })
        .catch(error => {
          // toast.error(error.map((msg: any) => msg.message || "Unknown error"));
          console.error(error);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  useEffect(() => {
    if (userInformation) {
      register({
        name: "customer_name",
        value: userInformation.name,
      });
      register({
        name: "customer_phone",
        value: userInformation.phone,
      });
      register({
        name: "customer_email",
        value: userInformation.email,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [register]);

  useEffect(() => {
    if (
      getObject(comment.data, "keys").length > 0 ||
      (comment.error && getObject(comment.error, "keys").length > 0)
    ) {
      const { data, error, loading } = comment;
      if (getObject(data, "keys").length > 0) {
        onSubmitComment(true);
        toast.info(data.message);
      } else if (error && getObject(error, "keys").length > 0) {
        // const {
        //   response: { data: dataError },
        // } = error;
        toast.error(error.map((item: ErrorField) => item.message).join(","));
        onSubmitComment(false);
      }
      setIsLoading(loading);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [comment]);

  useEffect(() => {
    return () => {
      dispatch(resetComment());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [needVerify, setNeedVerify] = useState(false);
  const [count, setCount] = useState<number>();

  useEffect(() => {
    if (notEmptyObject(errors)) {
      const countSave = Cookies.get("needVerify.RatingCommentForm");
      setCount(countSave ? Number(countSave) + 1 : count ? count + 1 : 1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errors]);

  useEffect(() => {
    if (count !== undefined) {
      setNeedVerify(count === 3);
      Cookies.set(
        "needVerify.RatingCommentForm",
        count ? count.toString() : "1",
        {
          expires: 1, // 1 day
        },
      );
    }
  }, [count]);

  useEffect(() => {
    const checkNeedVerifyCount = Cookies.get("needVerify.RatingCommentForm");
    if (checkNeedVerifyCount) {
      setCount(Number(checkNeedVerifyCount));
      if (Number(checkNeedVerifyCount) >= 3) {
        setNeedVerify(true);
      }
    }
  }, []);

  return (
    <form onSubmit={handleSubmit(onSubmit)} className={"comment-rating-form"}>
      {isLoading && <LoadingState />}
      {userInformation ? (
        <LoggedUserInfoBar>
          <LoggedUserInfo>
            <Icon iconName="user-review-icon" />
            <span>{userInformation.name || "unknown"}</span>
          </LoggedUserInfo>
          <OtherAction>
            <span>Không phải tài khoản này?</span>
            <Link href="#" onClick={onLogout}>
              <LogoutTextLink className="d-flex align-items-center">
                Đăng xuất
              </LogoutTextLink>
            </Link>
          </OtherAction>
        </LoggedUserInfoBar>
      ) : (
        <FormInputUserUnLogging>
          <FieldRowExtended>
            <FieldcellExtended>
              <FormInputUserUnLoggingInputWrapper>
                <FormInputUserUnLoggingTextfield
                  name="customer_name"
                  placeholder="Họ & Tên*"
                  value={getValues().customer_name}
                  refs={register({
                    required: {
                      value: false,
                      message: "Bạn chưa nhập - Họ và tên",
                    },
                  })}
                />
                {errors.customer_name && (
                  <Fielderror>{errors.customer_name.message}</Fielderror>
                )}
              </FormInputUserUnLoggingInputWrapper>
            </FieldcellExtended>
            <FieldcellExtended>
              <FormInputUserUnLoggingInputWrapper>
                <FormInputUserUnLoggingTextfield
                  name="customer_phone"
                  placeholder="Số Điện Thoại*"
                  value={getValues().customer_phone}
                  modifiers={
                    (touched && formState.touched.customer_phone) ||
                      errors.customer_phone
                      ? errors.customer_phone
                        ? ["invalid"]
                        : ["valid"]
                      : []
                  }
                  refs={register({
                    required: {
                      value: true,
                      message: "Bạn chưa nhập - Sđt",
                    },
                  })}
                />
                {errors.customer_phone && (
                  <Fielderror>{errors.customer_phone.message}</Fielderror>
                )}
              </FormInputUserUnLoggingInputWrapper>
            </FieldcellExtended>
            <FieldcellExtended>
              <FormInputUserUnLoggingInputWrapper>
                <FormInputUserUnLoggingTextfield
                  name="customer_email"
                  placeholder="Email*"
                  value={getValues().customer_email}
                  modifiers={
                    (touched && formState.touched.customer_email) ||
                      errors.customer_email
                      ? errors.customer_email
                        ? ["invalid"]
                        : ["valid"]
                      : []
                  }
                  refs={register({
                    required: {
                      value: true,
                      message: "Bạn chưa nhập - email",
                    },
                  })}
                />
                {errors.customer_email && (
                  <Fielderror>{errors.customer_email.message}</Fielderror>
                )}
              </FormInputUserUnLoggingInputWrapper>
            </FieldcellExtended>
          </FieldRowExtended>
        </FormInputUserUnLogging>
      )}
      <FieldRowExtended>
        <TextareaField
          name="replyContent"
          placeholder="Viết Trả Lời"
          value={getValues().replyContent}
          modifiers={
            (touched && formState.touched.replyContent) || errors.replyContent
              ? errors.replyContent
                ? ["invalid"]
                : ["valid"]
              : []
          }
          refs={register({
            required: {
              value: true,
              message: "Bạn chưa nhập - nội dung",
            },
          })}
        />
        {errors.replyContent && (
          <Fielderror>{errors.replyContent.message}</Fielderror>
        )}
      </FieldRowExtended>
      <SubmitBlock>
        {needVerify && KEY_CAPTCHA ? (
          <div className="form-recapcha">
            <form>
              <ReCAPTCHA
                sitekey={KEY_CAPTCHA}
                onChange={(value: any) => {
                  if (value) {
                    Cookies.remove("needVerify.RatingCommentForm");
                    setNeedVerify(false);
                    setCount(undefined);
                  }
                }}
              />
            </form>
          </div>
        ) : (
          <Button type="submit">GỬI</Button>
        )}
      </SubmitBlock>
    </form>
  );
};

export default RatingCommentForm;
